import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactionsFilterIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.14746 7.89746H21.1475",
			stroke: "#4D5055",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.14746 12.8975H18.1475",
			stroke: "#4D5055",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.14746 17.8975H15.1475",
			stroke: "#4D5055",
			strokeWidth: 1.5
		})
	]
});
export default SvgTransactionsFilterIcon;
